/* Van Dongen Verf, informatiesite (2-11-2026): binnenkomst per sectie en de merkencarrousel, overgenomen uit vdv-site.js van de webshop. */

/* Binnenkomst per sectie: één keer, gestaffeld (kop, tekst, beeld). Het script zet zelf de klasse js op html;
   zonder script of zonder IntersectionObserver blijft alles gewoon zichtbaar. */
(function () {
  'use strict';
  var groepen = Array.prototype.slice.call(document.querySelectorAll('[data-groep]'));
  if (!('IntersectionObserver' in window)) { return; }
  document.documentElement.classList.add('js');
  var io = new IntersectionObserver(function (items) {
    items.forEach(function (it) {
      if (it.isIntersecting) { it.target.classList.add('is-in'); io.unobserve(it.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
  groepen.forEach(function (g) { io.observe(g); });
  /* vangnet: na het afdrukken of als de observer om wat voor reden niet afgaat, niets verborgen laten */
  window.addEventListener('beforeprint', function () { groepen.forEach(function (g) { g.classList.add('is-in'); }); });
}());

/* Schuifrijen (merkencarrousel overgenomen uit concept_site/site.js).
   Merken: elke 3 seconden één logo verder, aan het eind terug naar het begin; stopt bij muis, focus, aanraken en verborgen tabblad.
   Rijen met data-carrousel="handmatig" bewegen nooit vanzelf. Geen automatische beweging bij "minder beweging". */
(function () {
  'use strict';
  var minder = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(document.querySelectorAll('[data-carrousel]'), function (car) {
    var rij = car.querySelector('.pg-car-rij');
    var vorige = car.querySelector('.pg-car-vorige');
    var volgende = car.querySelector('.pg-car-volgende');
    var handmatig = car.getAttribute('data-carrousel') === 'handmatig';
    if (!rij) { return; }
    var pauze = false, timer = null;
    function stap() { var li = rij.querySelector('li'); return li ? li.getBoundingClientRect().width : rij.clientWidth / 2; }
    function verder(richting) {
      var eind = rij.scrollWidth - rij.clientWidth - 2;
      if (richting > 0 && rij.scrollLeft >= eind) { rij.scrollTo({ left: 0 }); return; }
      if (richting < 0 && rij.scrollLeft <= 2) { rij.scrollTo({ left: rij.scrollWidth }); return; }
      rij.scrollBy({ left: richting * stap() });
    }
    function start() { if (minder || handmatig || timer) { return; } timer = setInterval(function () { if (!pauze && !document.hidden) { verder(1); } }, 3000); }
    if (vorige) { vorige.addEventListener('click', function () { verder(-1); }); }
    if (volgende) { volgende.addEventListener('click', function () { verder(1); }); }
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (e) { car.addEventListener(e, function () { pauze = true; }, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (e) { car.addEventListener(e, function () { pauze = false; }); });
    rij.addEventListener('keydown', function (e) {
      if (e.target !== rij) { return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); verder(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); verder(-1); }
    });
    start();
  });
}());
